import { get } from "lodash";
import {
  SET_AUTH_INIT,
  SET_AUTH_LOADER,
  SET_SHOW_PROMO_PAGE,
  TOGGLE_ALLOW_NEWSLETTERS_PAGE,
} from "../types";

export const initialState = {
  authLoader: false,
  authInit: false,
  allowNewslettersPage: false,
  showPromoPage: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_LOADER:
      return {
        ...state,
        authLoader: get(action, "payload"),
      };
    case SET_AUTH_INIT:
      return {
        ...state,
        authInit: get(action, "payload"),
      };
    case TOGGLE_ALLOW_NEWSLETTERS_PAGE:
      return {
        ...state,
        allowNewslettersPage: get(action, "payload"),
      };
    case SET_SHOW_PROMO_PAGE:
      return {
        ...state,
        showPromoPage: get(action, "payload"),
      };
    default:
      return state;
  }
};

export default reducer;
